<template>
    <div>
        <div class="row">
            <div class="flex md6 xs12">
                <sp-360-panel class="chart-widget" :title="$t('graficos156.abertasPorRegiao')" :tooltipOptions="tooltipAbertasPorRegiao">
                    <sp360-chart :data="topSolicitacoesPorRegiao" :options="opcoesGraficoBarra" type="vertical-bar"/>
                </sp-360-panel>
            </div>
            <div class="flex md6 xs12">
                <sp-360-panel class="chart-widget" :title="$t('graficos156.abertasPorOrgao')"
                 :tooltipOptions="tooltipAbertasPorOrgao">
                    <sp360-chart :data="topSolicitacoesPorOrgao" :options="opcoesGraficoBarra" type="vertical-bar"/>
                </sp-360-panel>
            </div>
        </div>
        <div class="row">
            <div class="flex md12 xs12">
            <sp-360-panel v-show='true'
                class="chart-widget"
                :title="$t('graficos156.abertasPorOrgaoLast30days')"
                :tooltipOptions="tooltipsAbertasPorOrgaoLast30days">
            <va-data-table id="tabelaOrgaoUltimoMes" ref="tabelaPorOrgaoUltimoMes"
                :apiMode="false"
                :data="dadosTabelaPorOrgaoUltimoMes.data"
                :fields="tableFieldsPorOrgao"
                :perPage="itemsPerPage"
                :onEachSide="onEachSide"
                :dataModeFilterableFields="dataModeFilterableFields"
                :sortFunctions="sortFunctions"
                :footerObj="footerObj"
                />
            </sp-360-panel>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import MetodosGlobais from '@/utils/MetodosGlobais'
import Constantes from '@/utils/ConstantesGlobais'
import CorUtil from '@/utils/CorUtils'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  name: 'bar-table-regiao-orgao',
  components: { Sp360Chart, Sp360Panel },
  data () {
    return {
      tooltipAbertasPorRegiao: {},
      tooltipAbertasPorOrgao: {},
      tooltipsAbertasPorOrgaoLast30days: {},
      onEachSide: 1,
      solicitacoesPorOrgaoUltimos30Dias: {},
      solicitacoesPorOrgao: {},
      topSolicitacoesPorRegiao: {},
      chartData: {},
      topSolicitacoesPorOrgao: {},
      opcoesGraficoBarra: {
        scales: {
          xAxes: [{
            // stacked: true
            ticks: {
              autoSkip: false,
              maxRotation: 19,
            },
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
            },
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('graficos156.servicosSolicitadosGraficosBarraEixoY'),
            },
          }],
        },
      },
      dadosTabelaPorOrgaoUltimoMes: {
        'data': [],
      },
      itemsPerPage: Constantes.PARAMETROS_DASHBOARD.SP156.QTD_DE_LINHAS_TABELAS_SOLICITACOES_POR_ORGAO_ULTIMO_MES,
      tableFieldsPorOrgao: [
        {
          name: 'orgao',
          title: this.$t('graficos156.tableFields.orgao'),
          width: '40%',
        },
        {
          name: 'recebidas',
          sortField: 'recebidas',
          title: this.$t('graficos156.tableFields.recebidas'),
          callback: MetodosGlobais.thousandSeparator,
        },
        {
          name: 'taxaAbertura',
          sortField: 'taxaAbertura',
          title: this.$t('graficos156.tableFields.taxaAbertura'),
        },
        {
          name: 'finalizadas',
          sortField: 'finalizadas',
          title: this.$t('graficos156.tableFields.finalizadas'),
          callback: MetodosGlobais.thousandSeparator,
        },

      ],
      dataModeFilterableFields: ['orgao'],
      sortFunctions: {
        'total': MetodosGlobais.ordenaTabelaParseInt,
        'taxaAbertura': MetodosGlobais.ordenaTabelaParseFloat,
        'finalizadas': MetodosGlobais.ordenaTabelaParseInt,
        'estoque': MetodosGlobais.ordenaTabelaParseInt,
      },
      footerObj: {},
    }
  },
  mounted () {
    this.tooltipAbertasPorRegiao = { content: this.$t('graficos156.tooltipAbertasPorRegiao'), placement: 'bottom' }
    this.tooltipAbertasPorOrgao = { content: this.$t('graficos156.tooltipAbertasPorOrgao'), placement: 'bottom' }
    this.tooltipsAbertasPorOrgaoLast30days = { content: this.$t('graficos156.tooltipsAbertasPorOrgaoLast30days'), placement: 'bottom' }
  },
  methods: {
    updateTablePorOrgaoUltimoMes (dados) {
      this.calcularTaxas(dados.data)
      this.$set(this.dadosTabelaPorOrgaoUltimoMes, 'data', _.orderBy(dados.data, 'recebidas', ['desc']))
      this.footerObj = this.dadosTabelaPorOrgaoUltimoMes.data.shift()
      this.footerObj.total = MetodosGlobais.thousandSeparator(this.footerObj.total)
      this.footerObj.finalizadas = MetodosGlobais.thousandSeparator(this.footerObj.finalizadas)
      this.footerObj.recebidas = MetodosGlobais.thousandSeparator(this.footerObj.recebidas)
      this.footerObj.abertas = MetodosGlobais.thousandSeparator(this.footerObj.abertas)
      this.footerObj.estoque = MetodosGlobais.thousandSeparator(this.footerObj.abertas)
      // this.$refs.tabelaPorOrgaoUltimoMes.update();
    },
    calcularTaxas (dados) {
      dados.forEach(element => {
        element.taxaAbertura = (element.recebidas / dados[0].recebidas * 100).toFixed(2) + '%'
        element.estoque = element.abertas
      })
    },
    populateVerticalBarPorRegiao (dados) {
      this.topSolicitacoesPorRegiao = {}
      this.topSolicitacoesPorRegiao.labels = []
      this.topSolicitacoesPorRegiao.datasets = []
      let dadosOrdenados = _.orderBy(dados.data, 'recebidas', 'desc')
      let dataset = {}
      dataset.data = []
      let numBarras = Constantes.PARAMETROS_DASHBOARD.SP156.QTD_BARRAS_SOLICITACOES_30D
      for (let i = 1; i <= numBarras; i++) {
        this.topSolicitacoesPorRegiao.labels.push(dadosOrdenados[i].nome)
        dataset.data.push((dadosOrdenados[i].recebidas / dadosOrdenados[0].recebidas * 100).toFixed(2))
      }
      let palette = this.$store.getters.palette
      dataset.label = this.$t('graficos156.legendaSolicitacoesRecebidasPorRegiao')
      dataset.backgroundColor = palette.primary
      dataset.borderColor = palette.transparent
      this.topSolicitacoesPorRegiao.datasets.push(dataset)
    },
    populateVerticalBarPorOrgao (dados) {
      this.topSolicitacoesPorOrgao = {}
      this.topSolicitacoesPorOrgao.labels = []
      this.topSolicitacoesPorOrgao.datasets = []
      let dadosOrdenados = _.orderBy(dados.data, 'abertas', 'desc')
      let dataset = {}
      dataset.data = []
      let numBarras = Constantes.PARAMETROS_DASHBOARD.SP156.QTD_BARRAS_SOLICITACOES_POR_ORGAO
      for (let i = 1; i <= numBarras; i++) {
        this.topSolicitacoesPorOrgao.labels.push(dadosOrdenados[i].orgao)
        dataset.data.push((dadosOrdenados[i].abertas / dadosOrdenados[0].abertas * 100).toFixed(2))
      }
      let palette = this.$store.getters.palette
      dataset.label = this.$t('graficos156.legendaDistribuicaoEstoquePorOrgao')
      dataset.backgroundColor = CorUtil.getVetorCoresSp360()[13]
      dataset.borderColor = palette.transparent
      this.topSolicitacoesPorOrgao.datasets.push(dataset)
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
